import { Input, Tooltip } from "antd";
import { useSearchParams } from "react-router-dom";
import { SearchIcon, InfoIcon } from "@/shared/assets/svg/icons";
import { InputSelect, type IStatus } from "@shared/ui";
import "./supervision-projects-filters.scss";

type DateFilter = "old" | "new";
type GsnFilter = "ALL" | "MGSN" | "SPBGSN";
type ObjectsFilter = "ALL" | "connected" | "disconnected";

export const SupervisionProjectsFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const currentDateFilter = (searchParams.get("date") as DateFilter) || "new";
  const currentGsnFilter = (searchParams.get("gsn") as GsnFilter) || "ALL";
  const currentObjectsFilter = (searchParams.get("objects") as ObjectsFilter) || "ALL";

  const dateStatuses = [
    { id: "old", status: "Сначала старые", icon: <></> },
    { id: "new", status: "Сначала новые", icon: <></> },
  ];

  const gsnStatuses = [
    { id: "ALL", status: "Все", icon: <></> },
    { id: "MGSN", status: "МГСН", icon: <></> },
    { id: "SPBGSN", status: "СПБГСН", icon: <></> },
  ];

  const objectsStatuses = [
    { id: "ALL", status: "Все", icon: <></> },
    { id: "connected", status: "Только подключенные", icon: <></> },
    { id: "disconnected", status: "Только не подключенные", icon: <></> },
  ];

  const selectedDateStatus = searchParams.has("date") ? dateStatuses.find(s => s.id === currentDateFilter) || null : null;
  const selectedGsnStatus = searchParams.has("gsn") ? gsnStatuses.find(s => s.id === currentGsnFilter) || null : null;
  const selectedObjectsStatus = searchParams.has("objects") ? objectsStatuses.find(s => s.id === currentObjectsFilter) || null : null;

  const updateDateFilter = (filter: DateFilter) => {
    const newParams = new URLSearchParams(searchParams);
    if (filter === "new") {
      newParams.delete("date");
    } else {
      newParams.set("date", filter);
    }
    setSearchParams(newParams);
  };

  const updateGsnFilter = (filter: GsnFilter) => {
    const newParams = new URLSearchParams(searchParams);
    if (filter === "ALL") {
      newParams.delete("gsn");
    } else {
      newParams.set("gsn", filter);
    }
    setSearchParams(newParams);
  };

  const updateObjectsFilter = (filter: ObjectsFilter) => {
    const newParams = new URLSearchParams(searchParams);
    if (filter === "ALL") {
      newParams.delete("objects");
    } else {
      newParams.set("objects", filter);
    }
    setSearchParams(newParams);
  };
  return (
    <div className="supervision-projects-filters">
      <Input
        className="project-members-search"
        suffix={<SearchIcon />}
        placeholder="Поиск"
        onInput={() => {}}
        value=""
        style={{ width: "240px", marginRight: "4px" }}
      />
      <Tooltip
        title="Поиск по ключевым словам, адресу, названиям документов и ГСН"
        placement="top"
        arrow={false}
      >
        <span className="project-members-search-tooltip">
          <InfoIcon />
        </span>
      </Tooltip>
      <InputSelect
        title="По дате"
        style={{ marginRight: "8px", marginLeft: "12px" }}
        statuses={dateStatuses}
        selectedStatus={selectedDateStatus}
        setSelectedStatus={(status: IStatus | null) => {
          if (status) {
            updateDateFilter(status.id as DateFilter);
          } else {
            updateDateFilter("new"); 
          }
        }}
        theme="transparent"
      />
      <InputSelect
        title="ГСН"
        style={{ marginRight: "8px", marginLeft: "12px" }}
        statuses={gsnStatuses}
        selectedStatus={selectedGsnStatus}
        setSelectedStatus={(status: IStatus | null) => {
          if (status) {
            updateGsnFilter(status.id as GsnFilter);
          } else {
            updateGsnFilter("ALL");
          }
        }}
        theme="transparent"
      />
      <InputSelect
        title="Обьекты"
        style={{ marginRight: "8px" }}
        statuses={objectsStatuses}
        selectedStatus={selectedObjectsStatus}
        setSelectedStatus={(status: IStatus | null) => {
          if (status) {
            updateObjectsFilter(status.id as ObjectsFilter);
          } else {
            updateObjectsFilter("ALL"); 
          }
        }}
        theme="transparent"
      />
    </div>
  );
};

